module.exports = __webpack_public_path__ + "static/img/banner2.24cb5d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2.png
// module id = pMVX
// module chunks = 1